import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';

import { Icon } from 'app/design-system/components/Icon';

import { useModalContext } from './context';

import styles from './Modal.module.scss';

export type ModalHeaderProps = {
  className?: string;
  children: ReactNode;
  'data-test'?: string;
};

const ModalHeader: FC<ModalHeaderProps> = ({
  children,
  className,
  ...props
}) => {
  const { onClose, closable } = useModalContext();

  return (
    <div className={classNames(styles.modalHeader, className)}
         data-test={props['data-test']}>
      {children}
      {closable && (
        <button className={styles.closeButton}
                type="button"
                data-test="close-btn"
                onClick={onClose}>
          <Icon icon="close-m" />
        </button>
      )}
    </div>
  );
};

export default ModalHeader;
